import ENV from "../../../config";
import * as api from "../../api/navigationApi";
import { SessionHelper } from "../../helpers/sessionHelper";

/**
 * reducers: `myFunc(state, payload)`
 * effects:  `async myFunc(payload, rootState)`
 */
const NavigationModel = {
  state: {
    sport: undefined,
    country: undefined,
    competition: undefined,
    filterNavNodeIds: [] as Array<any>,
    navigationTree: [] as Array<any>,
    updateBreadCrumb: false,
    navigationMenuOpen: false,
    displayBetplacementModal: false,
    loading: false,
    navigationNodeIds: [],
    previousRoute: null as string | null,
  },
  reducers: {
    /**
     * payload: { navigationTree }
     */
    updateNavigationTree: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return {
        ...state,
        navigationTree: payload.navigationTree,
        loading: false,
      };
    },

    /**
     * payload: { showBetplacementModal node}
     */
    updateShowBetplacementModal: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, displayBetplacementModal: payload };
    },

    /**
     * payload: { sports node}
     */
    updateSport: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, sport: payload };
    },

    /**
     * payload: { sports node}
     */
    updateCountry: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, country: payload };
    },

    /**
     * payload: { sports node}
     */
    updateCompetition: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, competition: payload };
    },

    /**
     * payload: { updateBreadcrumb }
     */
    updateBreadCrumb: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, updateBreadCrumb: payload };
    },

    /**
     * payload: { updateBreadcrumb }
     */
    checkIfMenuOpen: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, navigationMenuOpen: payload };
    },

    /**
     * payload: { loading }
     */
    setNavigationLoading: (state: Record<string, any>): any => {
      return { ...state, loading: true };
    },

    /**
     * payload: { }
     */
    resetModelToDefault: (state: Record<string, any>): any => {
      const defaultState = {
        sport: undefined,
        country: undefined,
        competition: undefined,
        filterNavNodeIds: [],
        navigationTree: [],
        updateBreadCrumb: false,
        navigationMenuOpen: false,
      };
      return { ...state, ...defaultState };
    },
    resetFiltering: (state: Record<string, any>): any => {
      return {
        ...state,
        sport: {
          id: ENV.DEFAULT_SOCCER_TAG_ID,
          name: "Soccer",
          translatedName: "Soccer",
          "navigation-node-ids": [ENV.DEFAULT_SOCCER_TAG_ID],
          type: "SPORT",
          nodes: [],
        },
        country: undefined,
        competition: undefined,
        filterNavNodeIds: ENV.DEFAULT_SOCCER_TAG_ID,
        navigationTree: [],
      };
    },

    /**
     * payload: { selectedSport, selectedCountry, selectedCompetition, navNodeIds }
     */
    updateFiltering: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return {
        ...state,
        sport: payload.selectedSport,
        country: payload.selectedCountry,
        competition: payload.selectedCompetition,
        filterNavNodeIds: payload.navNodeIds,
      };
    },
    restorePreviousFilterState: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      SessionHelper.saveNavigationNodeIds(payload);
      return { ...state, filterNavNodeIds: payload };
    },
    setNavigationNodeIds(state, nodeIds) {
      return {
        ...state,
        navigationNodeIds: nodeIds,
      };
    },
    resetNavigationNodeIds(state) {
      return {
        ...state,
        navigationNodeIds: [],
      };
    },

    /**
     * Store the current route as previous route
     */
    storePreviousRoute: (state: Record<string, any>, payload: string): any => {
      return {
        ...state,
        previousRoute: payload,
      };
    },

    /**
     * Clear the previous route
     */
    clearPreviousRoute: (state: Record<string, any>): any => {
      return {
        ...state,
        previousRoute: null,
      };
    },
  },
  effects: {
    /**
     * payload: { }
     */
    async loadNavigation(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setNavigationLoading();

      return api
        .fetchNavigationTree()
        .then((data: any) => {
          this.updateNavigationTree({
            navigationTree: data.trees,
          });
        })
        .catch(error => {
          throw error;
        });
    },
  },
};
export default NavigationModel;
